var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tabbed-menu",
    {
      attrs: {
        "initial-tab": _vm.defaultTab,
        tabs: [
          {
            name: _vm.tabs.traffic,
            label: _vm.resource("TouchpointStatistics_Traffic_Tab_Header")
          },
          {
            name: _vm.tabs.other,
            label: _vm.resource("TouchpointStatistics_Other_Tab_Header")
          }
        ],
        subMenu: _vm.isSubMenu
      }
    },
    [
      _c(
        "template",
        { slot: _vm.tabs.traffic },
        [
          _c("statistics-traffic", {
            staticClass: "tab-pane show active",
            attrs: { role: "tabpanel", "brick-id": _vm.brickId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: _vm.tabs.other },
        [
          _c("statistics-other", {
            staticClass: "tab-pane show active",
            attrs: { role: "tabpanel", "brick-id": _vm.brickId }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }